import React from 'react';
import { Box, Chip, Skeleton } from '@mui/material';
import {
    USER_GUIDE_CHIP_SKELETON_ITEMS,
    ALL_USER_GUIDE_CHIPS,
} from '../constants';
import { UserGuideChip } from '../types';

interface UserGuideScopeChipsProps {
    isLoading: boolean;
    selectedChip: string;
    availableChips: UserGuideChip[];
    onSelectChip: (chipName: string) => void;
}

const UserGuideScopeChips: React.FC<UserGuideScopeChipsProps> = ({
    isLoading,
    selectedChip,
    availableChips,
    onSelectChip,
}) => {
    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {isLoading ? (
                <Box
                    data-testid="user-guide-chip-skeleton"
                    sx={{
                        display: 'flex',
                        gap: 1,
                        flexWrap: 'wrap',
                    }}
                >
                    {USER_GUIDE_CHIP_SKELETON_ITEMS.map((skeletonKey) => (
                        <Skeleton
                            key={skeletonKey}
                            variant="rounded"
                            sx={{ borderRadius: 16 }}
                            width={96}
                            height={32}
                        />
                    ))}
                </Box>
            ) : (
                <>
                    <Chip
                        label={ALL_USER_GUIDE_CHIPS}
                        color={
                            selectedChip === ALL_USER_GUIDE_CHIPS
                                ? 'primary'
                                : 'default'
                        }
                        variant={
                            selectedChip === ALL_USER_GUIDE_CHIPS
                                ? 'solid'
                                : 'outlined'
                        }
                        onClick={() => onSelectChip(ALL_USER_GUIDE_CHIPS)}
                    />
                    {availableChips.map((chip) => (
                        <Chip
                            key={chip.name}
                            label={chip.name}
                            color={
                                selectedChip === chip.name
                                    ? 'primary'
                                    : 'default'
                            }
                            variant={
                                selectedChip === chip.name
                                    ? 'solid'
                                    : 'outlined'
                            }
                            onClick={() => onSelectChip(chip.name)}
                        />
                    ))}
                </>
            )}
        </Box>
    );
};

export default UserGuideScopeChips;
